import { Component } from '@angular/core';
import { BannerComponent } from 'app/shared/components/banner/banner.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { Themes } from 'themes';

@Component({
  selector: 'ez-server-error',
  imports: [BannerComponent, MainLayoutComponent],
  templateUrl: './server-error.component.html',
  styleUrl: './server-error.component.scss',
})
export class ServerErrorComponent {
  Themes = Themes;
}
